// @ts-check
// ====== Highlight helper ======
// Wrappa le occorrenze (case-insensitive) di `query` nel testo
// con <mark>...</mark>, escapando comunque l'output. Usabile ovunque
// la UI mostri risultati di ricerca.
//
// Uso: cell.innerHTML = highlightMatch(c.nome, currentQuery);

/**
 * @param {string} text
 * @param {string} query
 * @returns {string}
 */
function highlightMatch(text, query) {
  const t = text == null ? '' : String(text);
  if (!query) return _escape(t);
  const q = String(query).trim();
  if (!q) return _escape(t);
  const lower = t.toLowerCase();
  const ql = q.toLowerCase();
  let out = '';
  let i = 0;
  while (i < t.length) {
    const hit = lower.indexOf(ql, i);
    if (hit === -1) {
      out += _escape(t.slice(i));
      break;
    }
    out += _escape(t.slice(i, hit));
    out += '<mark class="search-hit">' + _escape(t.slice(hit, hit + ql.length)) + '</mark>';
    i = hit + ql.length;
  }
  return out;
}

function _escape(s) {
  return String(s).replace(
    /[&<>"']/g,
    (c) =>
      /** @type {Record<string,string>} */ ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[c]
  );
}

// @ts-ignore
globalThis.highlightMatch = highlightMatch;
export { highlightMatch };
